export default "__VITE_ASSET__45d4c998__"